import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';




const DealershipCard = ({ 
  dealership, 
  onEdit, 
  onDelete, 
  onToggleStatus,
  onPreview, 
  onViewLandingPage, 
  onViewVoucherPortal,
  onGenerateToken,
  isMobile = false 
}) => {
  const [showActions, setShowActions] = useState(false);

  const landingPageUrl = dealership?.urlSlug 
    ? `${window.location?.origin}/${dealership?.urlSlug}`
    : null;

  return (
    <div className="mobile-card swipeable touch-feedback-subtle">
      {/* Card Header */}
      <div className="flex items-start justify-between mobile-gap-sm mb-3">
        <div className="flex-1 min-w-0 flex items-center mobile-gap-sm">
          {/* Logo Display */}
          <div className="flex-1 min-w-0">
            <h3 className="mobile-subheading text-foreground truncate">
              {dealership?.name}
            </h3>
            <p className="mobile-caption text-muted-foreground mt-1">
              {dealership?.postalCode} {dealership?.city}
            </p>
          </div>
        </div>
        <button
          onClick={() => setShowActions(!showActions)}
          className="touch-target flex-shrink-0 p-2 rounded-lg hover:bg-muted transition-smooth touch-feedback"
          aria-label="More actions"
        >
          <Icon name="MoreVertical" size={isMobile ? 18 : 20} color="var(--color-muted-foreground)" />
        </button>
      </div>

      {/* Landing Page URL */}
      {landingPageUrl && (
        <div className="mb-3 p-3 bg-muted/30 rounded-lg border border-border">
          <div className="flex items-start mobile-gap-sm">
            <Icon name="Link" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-1">Landing Page</p>
              <a
                href={landingPageUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-primary hover:underline font-mono break-all inline-flex items-center gap-1"
              >
                {landingPageUrl}
                <Icon name="ExternalLink" size={12} />
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Card Details */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center mobile-gap-sm mobile-caption text-muted-foreground">
          <Icon name="Mail" size={16} />
          <span className="truncate">{dealership?.email}</span>
        </div>
        <div className="flex items-center mobile-gap-sm mobile-caption text-muted-foreground">
          <Icon name="Phone" size={16} />
          <span>{dealership?.phone}</span>
        </div>
        {dealership?.website && (
          <div className="flex items-center mobile-gap-sm mobile-caption text-muted-foreground">
            <Icon name="Globe" size={16} />
            <span className="truncate">{dealership?.website}</span>
          </div>
        )}
      </div>

      {/* Status Badge - Now Clickable */}
      <div className="flex items-center gap-2 mb-4">
        <button
          onClick={() => onToggleStatus?.(dealership)}
          className={`px-3 py-1 rounded-full mobile-caption font-medium transition-smooth touch-target ${
            dealership?.status === 'active' ?'bg-green-100 text-green-800 hover:bg-green-200' :'bg-gray-100 text-gray-800 hover:bg-gray-200'
          }`}
        >
          {dealership?.status === 'active' ? '✓ Aktiv' : '✕ Inaktiv'}
        </button>
        <span className="mobile-caption text-muted-foreground text-xs">
          (Klicken zum {dealership?.status === 'active' ? 'Deaktivieren' : 'Aktivieren'})
        </span>
      </div>

      {/* Mobile Action Sheet */}
      {showActions && (
        <div className="border-t border-border pt-3 space-y-2 animate-fade-in">
          <button
            onClick={() => {
              onToggleStatus?.(dealership);
              setShowActions(false);
            }}
            className={`touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-muted transition-smooth touch-feedback mobile-body ${
              dealership?.status === 'active' ? 'text-orange-600' : 'text-green-600'
            }`}
          >
            <Icon name={dealership?.status === 'active' ? 'XCircle' : 'CheckCircle'} size={18} />
            <span>{dealership?.status === 'active' ? 'Deaktivieren' : 'Aktivieren'}</span>
          </button>

          <button
            onClick={() => {
              onEdit?.(dealership);
              setShowActions(false);
            }}
            className="touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-muted transition-smooth touch-feedback mobile-body"
          >
            <Icon name="Edit" size={18} color="var(--color-primary)" />
            <span className="text-primary">Bearbeiten</span>
          </button>
          
          <button
            onClick={() => {
              onPreview?.(dealership);
              setShowActions(false);
            }}
            className="touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-muted transition-smooth touch-feedback mobile-body"
          >
            <Icon name="Eye" size={18} color="var(--color-foreground)" />
            <span>Vorschau</span>
          </button>
          
          <button
            onClick={() => {
              onViewLandingPage?.(dealership);
              setShowActions(false);
            }}
            className="touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-muted transition-smooth touch-feedback mobile-body"
          >
            <Icon name="ExternalLink" size={18} color="var(--color-foreground)" />
            <span>Landing Page öffnen</span>
          </button>
          
          {landingPageUrl && (
            <button
              onClick={() => {
                onGenerateToken?.(dealership);
                setShowActions(false);
              }}
              className="touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-muted transition-smooth touch-feedback mobile-body"
            >
              <Icon name="Key" size={18} color="var(--color-foreground)" />
              <span>Verifizierungs-Link</span>
            </button>
          )}
          
          <button
            onClick={() => {
              onViewVoucherPortal?.(dealership);
              setShowActions(false);
            }}
            className="touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-muted transition-smooth touch-feedback mobile-body"
          >
            <Icon name="CheckCircle" size={18} color="var(--color-foreground)" />
            <span>Voucher Portal</span>
          </button>
          
          <button
            onClick={() => {
              onDelete?.(dealership);
              setShowActions(false);
            }}
            className="touch-target-lg w-full flex items-center mobile-gap-sm px-3 py-2 rounded-lg hover:bg-destructive/10 transition-smooth touch-feedback mobile-body"
          >
            <Icon name="Trash2" size={18} color="var(--color-destructive)" />
            <span className="text-destructive">Löschen</span>
          </button>
        </div>
      )}

      {/* Quick Actions (when not showing full action sheet) */}
      {!showActions && (
        <div className="flex mobile-gap-sm">
          <button
            onClick={() => onEdit?.(dealership)}
            className="touch-target flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth touch-feedback mobile-body font-medium"
          >
            <Icon name="Edit" size={18} />
            <span>Bearbeiten</span>
          </button>
          <button
            onClick={() => onPreview?.(dealership)}
            className="touch-target flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-secondary text-secondary-foreground rounded-lg hover:bg-secondary/90 transition-smooth touch-feedback mobile-body font-medium"
          >
            <Icon name="Eye" size={18} />
            <span>Vorschau</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default DealershipCard;